import { MarketingCampaignType, Offer, ThresholdMarketingCampaignConfig, } from '../../1_types/genericTypes';
import { ORDER_TYPE_DELIVERY } from '../../constants';
import { displayPriceFormat } from '../../utils';

export const getTitleFromOffer = (offer: Offer): string => {
  if (!offer) return '';
  const config = offer.config as ThresholdMarketingCampaignConfig;
  switch (offer.type) {
    case MarketingCampaignType.FIXED_AMOUNT_DISCOUNT_AFTER_THRESHOLD:
      return `-${config.discount.value}€ dès ${config.threshold}€ d'achat`;

    case MarketingCampaignType.GLOBAL_PRODUCT_DISCOUNT_AFTER_THRESHOLD:
      return `-${config.discount.value}% dès ${config.threshold}€ d'achat`;

    case MarketingCampaignType.FREE_DELIVERY_AFTER_THRESHOLD:
      return `Livraison offerte dès ${config.threshold}€ d'achat`;

    case MarketingCampaignType.PRODUCT_DISCOUNT_AFTER_THRESHOLD:
      return `-${config.discount.value}% dès ${config.threshold}€ d'achat*`;

    default:
      break;
  }
  return '';
};

export const isThresholdCampaignValid = (
  offer: Offer,
  orderType: string
): boolean => {
  return !(
    offer.type === MarketingCampaignType.FREE_DELIVERY_AFTER_THRESHOLD &&
    orderType !== ORDER_TYPE_DELIVERY
  );
};

export const formatRemainingPrice = (remainingAmount: number): string =>
  displayPriceFormat(
    Math.max(0, Math.round(remainingAmount * 100) / 100),
    false,
    true,
    2
  );

export const calculateThresholdProgress = (
  totalProductPriceWithPromo: number | null | undefined,
  threshold: number
): number =>
  Math.min(
    1,
    Math.floor(((totalProductPriceWithPromo ?? 0) / threshold) * 100) / 100
  );
